import React, { useState } from "react";
import { Button } from "./ui/button";
import LocaleModal from "@/components/LocaleModal";
import { Separator } from "@/components/ui/separator"; // ✅ use shadcn separator
import { Link } from "react-router-dom";
import { Calendar, Earth, Globe, Images, Mails } from "lucide-react";

const footerColumns = [
/*   {
    label: "Palais",
    items: [
      { label: "Our story", link: "/about" },
      { label: "Manifesto", link: "/about" },
      { label: "Projects", link: "/about" },
      { label: "Journal", link: "/about" },
      { label: "Events", link: "/about" },
    ],
  }, */
/*   {
    label: "Discover",
    items: [
      { label: "How it works", link: "/discover/wearable-stories" },
      { label: "Wearable stories", link: "/discover/wearable-stories" },
      { label: "Fashion", link: "/discover/wearable-stories" },
      { label: "Jewellery", link: "/discover/wearable-stories" },
      { label: "Gifts", link: "/discover/wearable-stories" },
    ],
  }, */
  {
    label: "Palais Antoia",
    items: [
      { label: "Our story", link: "/about" },
/*       { label: "Bookings", link: "/bookings" }, */
      { label: "Memberships", link: "/requestaccess" },
/*       { label: "Returns", link: "/contact" }, */
      { label: "Contact", link: "/contact" },
    ],
  },
  {
    label: "Policy",
    items: [
      { label: "Privacy", link: "/privacy" },
      { label: "Terms", link: "/terms" },
      { label: "Cookies", link: "/privacy#cookies" },
    ],
  },
];

function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const cleanedEmail = email.trim().toLowerCase();
    if (!cleanedEmail) return;

    try {
      setLoading(true);

      const res = await fetch("/api/footerNewsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: cleanedEmail }),
      });

      // If your API returns JSON, parse it (but don't crash if it doesn't)
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        // Prefer server message if provided
        throw new Error(data?.error || "Something went wrong. Please try again.");
      }

      setSubmitted(true);
      setEmail("");
    } catch (err) {
      setError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <h3 className="text-sm uppercase tracking-wider text-black/60 font-sans mb-6 flex items-center">
        <Mails className="w-4 h-4 mr-2" />Sign up for updates
      </h3>

      {submitted ? (
        <p className="text-sm font-sans text-black">
          Thank you for joining. You’re now on our list.
        </p>
      ) : (
        <>
          <form onSubmit={handleSubmit} className="flex gap-2 w-full my-3">
            <input
              type="email"
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 border border-white bg-white px-3 py-2 text-sm rounded-none focus:outline-none focus:ring-0"
              disabled={loading}
            />

            <button
              type="submit"
              className="px-4 bg-black text-white text-lg rounded-none disabled:opacity-50"
              aria-label="Submit"
              disabled={loading}
            >
              {loading ? "…" : "→"}
            </button>
          </form>

          {error && <p className="text-xs text-red-600 mt-2">{error}</p>}

          <p className="text-xs text-neutral-500 mt-2">
            By entering your email address above, you consent to receiving our newsletter
            with access to our latest collections, events and initiatives. More details are
            provided in our{" "}
            <a href="/privacy" className="underline hover:text-black">
              privacy statement
            </a>
            .
          </p>
        </>
      )}
    </div>
  );
}

export { NewsletterSignup };


function Footer() {
  return (
    <>

      {/* <Separator className="border border-white/20 my-2" /> */}

      <footer className="bg-white/40 font-sans rounded-3xl m-2 mb-14 p-2">
        {/* TOP AREA */}
        <div className="">
          <div className="flex flex-col xl:flex-row  gap-x-2 gap-y-2 pb-0">


{/* LEFT: columns */}
<div className="flex-1">
<div className="items-start grid grid-cols-2 gap-6 md:flex md:gap-x-12 md:gap-y-10 justify-center md:justify-start text-black bg-white/50 border-2 border-white p-8 h-full w-[100%] rounded-[1.1rem]">
              {footerColumns.map((column, columnIndex) => (
                <React.Fragment key={column.label}>
                  <div className="grid grid-cols-1 md:text-left w-full text-center">
                    <h3 className="text-sm uppercase tracking-wider text-black/60 font-sans mb-6">
                      {column.label}
                    </h3>

                    {column.items.map((item) => (
                      <Link key={`${column.label}-${item.label}`} to={item.link}>
                        <Button
                          variant="link"
                          className="hover:no-underline hover:text-black/80 px-0 py-0 h-auto text-sm text-black/60"
                        >
                          {item.label}
                        </Button>
                      </Link>
                    ))}
                  </div>

                  {columnIndex === 1 && (
                    <Separator className="col-span-2 md:hidden my-2 bg-black/10" />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>


            {/* RIGHT: newsletter */}
            <div className="xl:w-fit bg-white/50 p-8 rounded-[1.1rem] border-2 border-white">
              <div className=" max-w-prose">
                <NewsletterSignup className="" />
              </div>
            </div>
          </div>



          {/* Quicklinks */}
          <div className="flex flex-col md:flex-row gap-1 w-full mt-2 mb-1">
            <Link to="/contact" className="w-full">
              <Button className="w-full rounded-none text-sm md:text-sm bg-black hover:bg-black/90" variant="">
                <Calendar className="w-4 h-4 mr-2" /> Get in touch →
              </Button>
            </Link>

            <Link to="/requestaccess" className="w-full">
              <Button className="w-full rounded-none text-sm md:text-sm bg-black hover:bg-black/90" variant="">
                <Earth className="w-4 h-4 mr-2" /> Become a member →
              </Button>
            </Link>
          </div>


          {/* Banner (smaller on mobile) */}
          <div className="relative mb-2">
            <img
              src={"/images/cypherloom_banner.png"}
              /* src={"/images/palais_antoia_hero_hor.png"} */
              alt="Palais d'Antoia banner"
              className="w-full object-cover rounded-none aspect-[16/8] md:aspect-[16/4]"
            />
            <div className="absolute inset-0 flex items-center justify-center text-white bg-black bg-opacity-30 rounded-none">
              <div className="text-center max-w-prose mx-auto p-3 md:p-4">
                
                <h1 className="text-2xl md:text-3xl mb-2 md:mb-6 font-kalice font-medium">
                  Palais Antoia<br />
                  <span className="italic">Home of Data Couture</span>
                </h1>
                <p className="text-sm md:text-md font-sans">
                  {new Date().toLocaleString("en-GB", {
                    timeZone: "Europe/Amsterdam",
                    year: "numeric",
                  })}</p>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="flex flex-col gap-2 items-center text-xs xl:flex-row md:justify-between md:items-center">
            {/* Social */}
            <div className="flex-col text-center lg:text-left justify-center md:justify-start bg-white/50 p-1 rounded-[1.1rem] border-2 border-white w-full">
            <a href="https://www.tiktok.com/@palaisantoia" target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" className="bg-transparent focus:outline-none focus:ring-0 text-black/60 hover:text-black hover:bg-transparent">
                  TikTok
                </Button>
              </a>
              <a href="https://www.instagram.com/palaisantoia" target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" className="bg-transparent focus:outline-none focus:ring-0 text-black/60 hover:text-black hover:bg-transparent">
                  Instagram
                </Button>
              </a>
              <a href="https://twitter.com/palaisantoia" target="_blank" rel="noopener noreferrer">
      <Button variant="secondary" className="bg-transparent focus:outline-none focus:ring-0 text-black/60 hover:text-black hover:bg-transparent">
        x
      </Button>
    </a>
              <a href="https://www.facebook.com/palaisantoia" target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" className="bg-transparent focus:outline-none focus:ring-0 text-black/60 hover:text-black hover:bg-transparent">
                  Facebook
                </Button>
              </a>

    <a href="https://www.snapchat.com/explore/cypherloom" target="_blank" rel="noopener noreferrer">
      <Button variant="secondary" className="bg-transparent focus:outline-none focus:ring-0 text-black/60 hover:text-black hover:bg-transparent">
        Snapchat
      </Button>
    </a>
              <a href="https://www.linkedin.com/company/palaisantoia" target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" className="bg-transparent focus:outline-none focus:ring-0 text-black/60 hover:text-black hover:bg-transparent">
                  LinkedIn
                </Button>
              </a>
            </div>

{/*             <div className="flex items-center my-auto justify-center overflow-visible shrink-0 px-2">
          <Link to="/">
            <img src="/logos/C_Glyph.svg" alt="Cypherloom Logo" className="h-8 opacity-60 hover:opacity-100" />
          </Link>
        </div> */}
<div className="flex space-x-2 w-full md:w-fit">
<Link to="/">
<Button variant="secondary" className=" focus:outline-none focus:ring-0 focus-visible:outline-none bg-white/50 p-6 rounded-[1.1rem] border-2 border-white text-black/60 hover:text-black w-full">
                  <Images className="w-4 h-4 mr-2" /> Press kit {/* <span>United Kingdom (English)</span> */}
                </Button>
                </Link>

            {/* Locale */}
            <LocaleModal
              trigger={
                <Button variant="secondary" className=" focus:outline-none focus:ring-0 focus-visible:outline-none bg-white/50 p-6 rounded-[1.1rem] border-2 border-white text-black/60 hover:text-black w-full">
                  <Globe className="w-4 h-4 mr-2" />Language / Region {/* <span>United Kingdom (English)</span> */}
                </Button>
              }
              onApply={({ region }) => {
                window.location.pathname = `/${region}`;
              }}
            />
            </div>

<div className="flex items-center my-auto justify-center overflow-visible shrink-0 px-2 py-2 md:py-0">
          <Link to="/about">
            <img src="/logos/C_Glyph.svg" alt="Cypherloom Logo" className="h-8 opacity-80 hover:opacity-100" />
          </Link>
        </div>

          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
